export default [
  {
    path: "",
    name: "user-documents-list",
    component: () => import("@/view/pages/user/documents/DocumentList.vue"),
    meta: { requiresAuth: true },
  },
];
